// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_parenCounter = require("./MM_parenCounter.bs.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");

function subsClone(subs) {
  return {
          size: subs.size,
          begins: subs.begins.slice(),
          ends: subs.ends.slice(),
          exprs: subs.exprs.slice(),
          isDefined: subs.isDefined.slice()
        };
}

function subsEq(a, b) {
  if (!(a.size === b.size && a.isDefined.every(function (b) {
            return b;
          }) && b.isDefined.every(function (b) {
            return b;
          }))) {
    return false;
  }
  var res = true;
  var v = 0;
  while(res && v < a.size) {
    var aExpr = Caml_array.get(a.exprs, v);
    var aBegin = Caml_array.get(a.begins, v);
    var aEnd = Caml_array.get(a.ends, v);
    var aExprLen = (aEnd - aBegin | 0) + 1 | 0;
    var bExpr = Caml_array.get(b.exprs, v);
    var bBegin = Caml_array.get(b.begins, v);
    var bEnd = Caml_array.get(b.ends, v);
    var bExprLen = (bEnd - bBegin | 0) + 1 | 0;
    if (aExprLen === bExprLen) {
      var ai = aBegin;
      var bi = bBegin;
      while(res && ai <= aEnd) {
        res = Caml_array.get(aExpr, ai) === Caml_array.get(bExpr, bi);
        ai = ai + 1 | 0;
        bi = bi + 1 | 0;
      };
    } else {
      res = false;
    }
    v = v + 1 | 0;
  };
  return res;
}

function subsHash(subs) {
  if (!subs.isDefined.every(function (b) {
          return b;
        })) {
    return 0;
  }
  var hash = 0;
  var v = 0;
  while(v < subs.size) {
    hash = Expln_utils_common.hash2(hash, Expln_utils_common.hashArrIntFromTo(Caml_array.get(subs.exprs, v), Caml_array.get(subs.begins, v), Caml_array.get(subs.ends, v)));
    v = v + 1 | 0;
  };
  return hash;
}

function lengthOfGap(leftConstPartIdx, constParts, exprLength) {
  if (leftConstPartIdx < 0) {
    return Caml_array.get(Caml_array.get(constParts, 0), 0);
  } else if (leftConstPartIdx < (constParts.length - 1 | 0)) {
    return (Caml_array.get(Caml_array.get(constParts, leftConstPartIdx + 1 | 0), 0) - Caml_array.get(Caml_array.get(constParts, leftConstPartIdx), 1) | 0) - 1 | 0;
  } else {
    return (exprLength - Caml_array.get(Caml_array.get(constParts, leftConstPartIdx), 1) | 0) - 1 | 0;
  }
}

function lengthOfGap2(leftConstPartIdx, constParts, exprLength) {
  if (leftConstPartIdx < 0) {
    return Caml_array.get(constParts.begins, 0);
  } else if (leftConstPartIdx < (constParts.length - 1 | 0)) {
    return (Caml_array.get(constParts.begins, leftConstPartIdx + 1 | 0) - Caml_array.get(constParts.ends, leftConstPartIdx) | 0) - 1 | 0;
  } else {
    return (exprLength - Caml_array.get(constParts.ends, leftConstPartIdx) | 0) - 1 | 0;
  }
}

function createConstParts(expr) {
  var constParts = [];
  for(var i = 0 ,i_finish = expr.length; i < i_finish; ++i){
    var constPartsLength = constParts.length;
    if (Caml_array.get(expr, i) < 0) {
      if (constPartsLength === 0 || Caml_array.get(Caml_array.get(constParts, constPartsLength - 1 | 0), 1) >= 0) {
        constParts.push([
              i,
              -1
            ]);
      }
      
    } else if (constPartsLength > 0 && Caml_array.get(Caml_array.get(constParts, constPartsLength - 1 | 0), 1) < 0) {
      Caml_array.set(Caml_array.get(constParts, constPartsLength - 1 | 0), 1, i - 1 | 0);
    }
    
  }
  var constPartsLength$1 = constParts.length;
  var exprLength = expr.length;
  if (constPartsLength$1 > 0 && Caml_array.get(Caml_array.get(constParts, constPartsLength$1 - 1 | 0), 1) < 0) {
    Caml_array.set(Caml_array.get(constParts, constPartsLength$1 - 1 | 0), 1, exprLength - 1 | 0);
  }
  var result_begins = new Array(constPartsLength$1);
  var result_ends = new Array(constPartsLength$1);
  var result_remainingMinLength = new Array(constPartsLength$1);
  var result = {
    length: constPartsLength$1,
    begins: result_begins,
    ends: result_ends,
    remainingMinLength: result_remainingMinLength
  };
  var remainingMinLength = 0;
  for(var i$1 = constPartsLength$1 - 1 | 0; i$1 >= 0; --i$1){
    Caml_array.set(result_begins, i$1, Caml_array.get(Caml_array.get(constParts, i$1), 0));
    Caml_array.set(result_ends, i$1, Caml_array.get(Caml_array.get(constParts, i$1), 1));
    remainingMinLength = (remainingMinLength + ((Caml_array.get(result_ends, i$1) - Caml_array.get(result_begins, i$1) | 0) + 1 | 0) | 0) + lengthOfGap(i$1, constParts, exprLength) | 0;
    Caml_array.set(result_remainingMinLength, i$1, remainingMinLength);
  }
  return result;
}

function createMatchingConstParts(constParts) {
  return {
          length: constParts.length,
          begins: new Array(constParts.length),
          ends: new Array(constParts.length),
          remainingMinLength: []
        };
}

function iterateConstParts(frmExpr, expr, frmConstParts, constParts, idxToMatch, parenCnt, consumer) {
  var invokeNext = function (param) {
    return iterateConstParts(frmExpr, expr, frmConstParts, constParts, idxToMatch + 1 | 0, parenCnt, consumer);
  };
  var exprLen = expr.length;
  var frmExprLen = frmExpr.length;
  if (exprLen < frmExprLen) {
    return /* Continue */0;
  }
  if (idxToMatch === frmConstParts.length) {
    if (!(frmConstParts.length > 0 && Caml_array.get(constParts.ends, idxToMatch - 1 | 0) !== (exprLen - 1 | 0))) {
      return Curry._1(consumer, constParts);
    }
    if (Caml_array.get(frmConstParts.ends, idxToMatch - 1 | 0) === (frmExprLen - 1 | 0)) {
      return /* Continue */0;
    }
    var frmRemainingGapLength = lengthOfGap2(idxToMatch - 1 | 0, frmConstParts, frmExprLen);
    var remainingGapLength = lengthOfGap2(idxToMatch - 1 | 0, constParts, exprLen);
    if (remainingGapLength < frmRemainingGapLength) {
      return /* Continue */0;
    }
    MM_parenCounter.parenCntReset(parenCnt);
    var pState = /* Balanced */0;
    var i = Caml_array.get(constParts.ends, idxToMatch - 1 | 0) + 1 | 0;
    while(i < exprLen && pState !== /* Failed */2) {
      pState = MM_parenCounter.parenCntPut(parenCnt, Caml_array.get(expr, i));
      i = i + 1 | 0;
    };
    if (pState === /* Balanced */0) {
      return Curry._1(consumer, constParts);
    } else {
      return /* Continue */0;
    }
  }
  if (idxToMatch === 0 && Caml_array.get(frmConstParts.begins, 0) === 0) {
    if ((exprLen - 1 | 0) < Caml_array.get(frmConstParts.ends, 0)) {
      return /* Continue */0;
    }
    var res;
    var maxI = Caml_array.get(frmConstParts.ends, 0);
    var i$1 = 0;
    while(Belt_Option.isNone(res) && i$1 <= maxI) {
      if (Caml_array.get(frmExpr, i$1) !== Caml_array.get(expr, i$1)) {
        res = /* Continue */0;
      }
      i$1 = i$1 + 1 | 0;
    };
    var instr = res;
    if (instr !== undefined) {
      return instr;
    } else {
      Caml_array.set(constParts.begins, 0, 0);
      Caml_array.set(constParts.ends, 0, maxI);
      return invokeNext(undefined);
    }
  }
  var begin = idxToMatch === 0 ? 0 : Caml_array.get(constParts.ends, idxToMatch - 1 | 0) + 1 | 0;
  var maxBegin = exprLen - Caml_array.get(frmConstParts.remainingMinLength, idxToMatch) | 0;
  MM_parenCounter.parenCntReset(parenCnt);
  var pState$1 = /* Balanced */0;
  var numOfVars = lengthOfGap2(idxToMatch - 1 | 0, frmConstParts, frmExprLen);
  for(var _for = 1; _for <= numOfVars; ++_for){
    pState$1 = MM_parenCounter.parenCntPut(parenCnt, Caml_array.get(expr, begin));
    begin = begin + 1 | 0;
  }
  var partLen = (Caml_array.get(frmConstParts.ends, idxToMatch) - Caml_array.get(frmConstParts.begins, idxToMatch) | 0) + 1 | 0;
  var instr$1 = /* Continue */0;
  while(begin <= maxBegin && pState$1 !== /* Failed */2 && instr$1 === /* Continue */0) {
    if (pState$1 === /* Balanced */0) {
      var matchedLen = 0;
      var cmpRes = true;
      while(matchedLen < partLen && cmpRes) {
        cmpRes = Caml_array.get(frmExpr, Caml_array.get(frmConstParts.begins, idxToMatch) + matchedLen | 0) === Caml_array.get(expr, begin + matchedLen | 0);
        matchedLen = matchedLen + 1 | 0;
      };
      if (matchedLen === partLen && cmpRes) {
        Caml_array.set(constParts.begins, idxToMatch, begin);
        Caml_array.set(constParts.ends, idxToMatch, (begin + partLen | 0) - 1 | 0);
        instr$1 = invokeNext(undefined);
        MM_parenCounter.parenCntReset(parenCnt);
      }
      
    }
    pState$1 = MM_parenCounter.parenCntPut(parenCnt, Caml_array.get(expr, begin));
    begin = begin + 1 | 0;
  };
  return instr$1;
}

function createVarGroups(frmExpr, frmConstParts) {
  var frmExprLen = frmExpr.length;
  if (frmConstParts.length === 0) {
    return [{
              leftConstPartIdx: -1,
              frmExpr: frmExpr,
              varsBeginIdx: 0,
              numOfVars: frmExprLen,
              exprBeginIdx: 0,
              exprEndIdx: 0
            }];
  }
  var res = [];
  if (Caml_array.get(frmConstParts.begins, 0) !== 0) {
    res.push({
          leftConstPartIdx: -1,
          frmExpr: frmExpr,
          varsBeginIdx: 0,
          numOfVars: Caml_array.get(frmConstParts.begins, 0),
          exprBeginIdx: 0,
          exprEndIdx: 0
        });
  }
  for(var i = 0 ,i_finish = frmConstParts.length - 2 | 0; i <= i_finish; ++i){
    res.push({
          leftConstPartIdx: i,
          frmExpr: frmExpr,
          varsBeginIdx: Caml_array.get(frmConstParts.ends, i) + 1 | 0,
          numOfVars: lengthOfGap2(i, frmConstParts, frmExprLen),
          exprBeginIdx: 0,
          exprEndIdx: 0
        });
  }
  var lastConstPartIdx = frmConstParts.length - 1 | 0;
  if (Caml_array.get(frmConstParts.ends, lastConstPartIdx) !== (frmExprLen - 1 | 0)) {
    res.push({
          leftConstPartIdx: lastConstPartIdx,
          frmExpr: frmExpr,
          varsBeginIdx: Caml_array.get(frmConstParts.ends, lastConstPartIdx) + 1 | 0,
          numOfVars: lengthOfGap2(lastConstPartIdx, frmConstParts, frmExprLen),
          exprBeginIdx: 0,
          exprEndIdx: 0
        });
  }
  return res;
}

function initVarGroups(varGroups, constParts, expr) {
  var exprLen = expr.length;
  if (constParts.length === 0) {
    Caml_array.get(varGroups, 0).exprBeginIdx = 0;
    Caml_array.get(varGroups, 0).exprEndIdx = exprLen - 1 | 0;
  } else {
    varGroups.forEach(function (grp) {
          if (grp.leftConstPartIdx === -1) {
            grp.exprBeginIdx = 0;
            grp.exprEndIdx = Caml_array.get(constParts.begins, 0) - 1 | 0;
          } else if (grp.leftConstPartIdx === (constParts.length - 1 | 0)) {
            grp.exprBeginIdx = Caml_array.get(constParts.ends, grp.leftConstPartIdx) + 1 | 0;
            grp.exprEndIdx = exprLen - 1 | 0;
          } else {
            grp.exprBeginIdx = Caml_array.get(constParts.ends, grp.leftConstPartIdx) + 1 | 0;
            grp.exprEndIdx = Caml_array.get(constParts.begins, grp.leftConstPartIdx + 1 | 0) - 1 | 0;
          }
        });
    varGroups.sort(function (g1, g2) {
          if (g1.numOfVars < g2.numOfVars) {
            return -1;
          } else if (g1.numOfVars === g2.numOfVars) {
            return 0;
          } else {
            return 1;
          }
        });
  }
}

function iterateVarGroups(expr, subs, varGroups, curGrpIdx, curVarIdx, subExprBeginIdx, parenCnt, consumer) {
  var grp = Caml_array.get(varGroups, curGrpIdx);
  var frmVar = Caml_array.get(grp.frmExpr, grp.varsBeginIdx + curVarIdx | 0);
  var maxSubExprLength = ((grp.exprEndIdx - subExprBeginIdx | 0) + 1 | 0) - ((grp.numOfVars - curVarIdx | 0) - 1 | 0) | 0;
  var invokeNext = function (subExprLength) {
    if (curVarIdx < (grp.numOfVars - 1 | 0)) {
      return iterateVarGroups(expr, subs, varGroups, curGrpIdx, curVarIdx + 1 | 0, subExprBeginIdx + subExprLength | 0, parenCnt, consumer);
    } else if (curGrpIdx < (varGroups.length - 1 | 0)) {
      return iterateVarGroups(expr, subs, varGroups, curGrpIdx + 1 | 0, 0, Caml_array.get(varGroups, curGrpIdx + 1 | 0).exprBeginIdx, parenCnt, consumer);
    } else {
      return Curry._1(consumer, subs);
    }
  };
  var continueInstr = /* Continue */0;
  if (Caml_array.get(subs.isDefined, frmVar)) {
    var existingExpr = Caml_array.get(subs.exprs, frmVar);
    var existingExprBeginIdx = Caml_array.get(subs.begins, frmVar);
    var existingExprLen = (Caml_array.get(subs.ends, frmVar) - existingExprBeginIdx | 0) + 1 | 0;
    if (existingExprLen <= maxSubExprLength && (curVarIdx < (grp.numOfVars - 1 | 0) || existingExprLen === maxSubExprLength)) {
      var checkedLen = 0;
      while(checkedLen < existingExprLen && Caml_array.get(existingExpr, existingExprBeginIdx + checkedLen | 0) === Caml_array.get(expr, subExprBeginIdx + checkedLen | 0)) {
        checkedLen = checkedLen + 1 | 0;
      };
      if (checkedLen === existingExprLen) {
        continueInstr = invokeNext(existingExprLen);
      }
      
    }
    
  } else {
    Caml_array.set(subs.isDefined, frmVar, true);
    Caml_array.set(subs.exprs, frmVar, expr);
    Caml_array.set(subs.begins, frmVar, subExprBeginIdx);
    if (curVarIdx === (grp.numOfVars - 1 | 0)) {
      Caml_array.set(subs.ends, frmVar, grp.exprEndIdx);
      continueInstr = invokeNext(maxSubExprLength);
    } else {
      var subExprLength = 1;
      var end = subExprBeginIdx;
      MM_parenCounter.parenCntReset(parenCnt);
      var pStatus = /* Balanced */0;
      while(subExprLength <= maxSubExprLength && continueInstr === /* Continue */0 && pStatus !== /* Failed */2) {
        Caml_array.set(subs.ends, frmVar, end);
        pStatus = MM_parenCounter.parenCntPut(parenCnt, Caml_array.get(expr, end));
        if (pStatus === /* Balanced */0) {
          continueInstr = invokeNext(subExprLength);
          MM_parenCounter.parenCntReset(parenCnt);
        }
        subExprLength = subExprLength + 1 | 0;
        end = end + 1 | 0;
      };
    }
    Caml_array.set(subs.isDefined, frmVar, false);
  }
  return continueInstr;
}

function iterateSubstitutions(frmExpr, expr, frmConstParts, constParts, varGroups, subs, parenCnt, consumer) {
  if (subs.size === 0) {
    if (Caml_obj.equal(frmExpr, expr)) {
      return Curry._1(consumer, subs);
    } else {
      return /* Continue */0;
    }
  }
  var exprLen = expr.length;
  var frmExprLen = frmExpr.length;
  if (exprLen < frmExprLen) {
    return /* Continue */0;
  } else {
    return iterateConstParts(frmExpr, expr, frmConstParts, constParts, 0, parenCnt, (function (constParts) {
                  if (varGroups.length > 0) {
                    initVarGroups(varGroups, constParts, expr);
                    return iterateVarGroups(expr, subs, varGroups, 0, 0, Caml_array.get(varGroups, 0).exprBeginIdx, parenCnt, consumer);
                  } else {
                    return Curry._1(consumer, subs);
                  }
                }));
  }
}

function createSubs(numOfVars) {
  return {
          size: numOfVars,
          begins: Belt_Array.make(numOfVars, 0),
          ends: Belt_Array.make(numOfVars, 0),
          exprs: Belt_Array.make(numOfVars, []),
          isDefined: Belt_Array.make(numOfVars, false)
        };
}

function prepareFrmSubsDataForFrame(frame) {
  var hypsE = frame.hyps.filter(function (hyp) {
        return hyp.typ === /* E */1;
      });
  var frmConstPartsArr = [];
  var constPartsArr = [];
  var varGroupsArr = [];
  hypsE.forEach(function (hyp) {
        var frmConstParts = createConstParts(hyp.expr);
        var constParts = createMatchingConstParts(frmConstParts);
        var varGroups = createVarGroups(hyp.expr, frmConstParts);
        frmConstPartsArr.push(frmConstParts);
        constPartsArr.push(constParts);
        varGroupsArr.push(varGroups);
      });
  var frmConstParts = createConstParts(frame.asrt);
  var constParts = createMatchingConstParts(frmConstParts);
  var varGroups = createVarGroups(frame.asrt, frmConstParts);
  frmConstPartsArr.push(frmConstParts);
  constPartsArr.push(constParts);
  varGroupsArr.push(varGroups);
  var subs = createSubs(frame.numOfVars);
  return {
          frame: frame,
          hypsE: hypsE,
          numOfHypsE: hypsE.length,
          frmConstParts: frmConstPartsArr,
          constParts: constPartsArr,
          varGroups: varGroupsArr,
          subs: subs
        };
}

function prepareFrmSubsData(ctx, asrtsToSkipOpt, param) {
  var asrtsToSkip = asrtsToSkipOpt !== undefined ? Caml_option.valFromOption(asrtsToSkipOpt) : Belt_HashSetString.make(0);
  var frms = [];
  MM_context.forEachFrame(ctx, (function (frame) {
          if (!Belt_HashSetString.has(asrtsToSkip, frame.label)) {
            frms.push(prepareFrmSubsDataForFrame(frame));
          }
          
        }));
  return Belt_MapString.fromArray(frms.map(function (frm) {
                  return [
                          frm.frame.label,
                          frm
                        ];
                }));
}

function applySubs(frmExpr, subs, createWorkVar) {
  var resultSize = {
    contents: 0
  };
  frmExpr.forEach(function (s) {
        if (s < 0 || !Caml_array.get(subs.isDefined, s)) {
          resultSize.contents = resultSize.contents + 1 | 0;
        } else {
          resultSize.contents = resultSize.contents + ((Caml_array.get(subs.ends, s) - Caml_array.get(subs.begins, s) | 0) + 1 | 0) | 0;
        }
      });
  var res = new Array(resultSize.contents);
  var e = 0;
  var r = 0;
  while(r < resultSize.contents) {
    var s = Caml_array.get(frmExpr, e);
    if (s < 0) {
      Caml_array.set(res, r, s);
      r = r + 1 | 0;
    } else if (Caml_array.get(subs.isDefined, s)) {
      var subExpr = Caml_array.get(subs.exprs, s);
      var len = (Caml_array.get(subs.ends, s) - Caml_array.get(subs.begins, s) | 0) + 1 | 0;
      Expln_utils_common.copySubArray(subExpr, Caml_array.get(subs.begins, s), res, r, len);
      r = r + len | 0;
    } else {
      Caml_array.set(res, r, Curry._1(createWorkVar, s));
      r = r + 1 | 0;
    }
    e = e + 1 | 0;
  };
  return res;
}

function verifyDisjoints(frmDisj, subs, isDisjInCtx, debugLevel) {
  var res = {
    contents: undefined
  };
  Belt_MapInt.forEach(frmDisj, (function (n, ms) {
          if (Belt_Option.isNone(res.contents)) {
            return Belt_SetInt.forEach(ms, (function (m) {
                          if (!Belt_Option.isNone(res.contents)) {
                            return ;
                          }
                          var nExpr = Caml_array.get(subs.exprs, n);
                          var nExprBegin = Caml_array.get(subs.begins, n);
                          var nExprEnd = Caml_array.get(subs.ends, n);
                          var mExpr = Caml_array.get(subs.exprs, m);
                          var mExprBegin = Caml_array.get(subs.begins, m);
                          var mExprEnd = Caml_array.get(subs.ends, m);
                          for(var nExprI = nExprBegin; nExprI <= nExprEnd; ++nExprI){
                            if (Belt_Option.isNone(res.contents)) {
                              var nExprSym = Caml_array.get(nExpr, nExprI);
                              if (nExprSym >= 0) {
                                for(var mExprI = mExprBegin; mExprI <= mExprEnd; ++mExprI){
                                  if (Belt_Option.isNone(res.contents)) {
                                    var mExprSym = Caml_array.get(mExpr, mExprI);
                                    if (mExprSym >= 0) {
                                      if (nExprSym === mExprSym) {
                                        if (debugLevel === 0) {
                                          res.contents = /* UnifErr */0;
                                        } else {
                                          res.contents = {
                                            TAG: /* DisjCommonVar */0,
                                            frmVar1: n,
                                            expr1: nExpr.slice(nExprBegin, nExprEnd + 1 | 0),
                                            frmVar2: m,
                                            expr2: mExpr.slice(mExprBegin, mExprEnd + 1 | 0),
                                            commonVar: nExprSym
                                          };
                                        }
                                      } else if (!Curry._2(isDisjInCtx, nExprSym, mExprSym)) {
                                        if (debugLevel === 0) {
                                          res.contents = /* UnifErr */0;
                                        } else {
                                          res.contents = {
                                            TAG: /* Disj */1,
                                            frmVar1: n,
                                            expr1: nExpr.slice(nExprBegin, nExprEnd + 1 | 0),
                                            var1: nExprSym,
                                            frmVar2: m,
                                            expr2: mExpr.slice(mExprBegin, mExprEnd + 1 | 0),
                                            var2: mExprSym
                                          };
                                        }
                                      }
                                      
                                    }
                                    
                                  }
                                  
                                }
                              }
                              
                            }
                            
                          }
                        }));
          }
          
        }));
  return res.contents;
}

function test_iterateConstParts(ctx, frmExpr, expr, parens) {
  var constPartsToArr = function (constParts) {
    return constParts.begins.map(function (b, i) {
                return [
                        b,
                        Caml_array.get(constParts.ends, i)
                      ];
              });
  };
  var parenCnt = MM_parenCounter.parenCntMake(MM_context.ctxStrToIntsExn(ctx, parens), undefined, undefined);
  var frmConstParts = createConstParts(frmExpr);
  var constParts = createMatchingConstParts(frmConstParts);
  var matchingConstParts = [];
  iterateConstParts(frmExpr, expr, frmConstParts, constParts, 0, parenCnt, (function (constParts) {
          matchingConstParts.push(constPartsToArr(constParts));
          return /* Continue */0;
        }));
  return [
          constPartsToArr(frmConstParts),
          matchingConstParts
        ];
}

function test_iterateSubstitutions(ctx, frmExpr, expr, parens) {
  var parenCnt = MM_parenCounter.parenCntMake(MM_context.ctxStrToIntsExn(ctx, parens), undefined, undefined);
  var frmConstParts = createConstParts(frmExpr);
  var constParts = createMatchingConstParts(frmConstParts);
  var varGroups = createVarGroups(frmExpr, frmConstParts);
  var numOfVars = Belt_SetInt.size(Belt_SetInt.fromArray(frmExpr.filter(function (i) {
                return i >= 0;
              })));
  var subs = createSubs(numOfVars);
  var result = [];
  iterateSubstitutions(frmExpr, expr, frmConstParts, constParts, varGroups, subs, parenCnt, (function (subs) {
          var res = [];
          for(var i = 0; i < numOfVars; ++i){
            res.push(Caml_array.get(subs.exprs, i).slice(Caml_array.get(subs.begins, i), Caml_array.get(subs.ends, i) + 1 | 0));
          }
          result.push(res);
          return /* Continue */0;
        }));
  return result;
}

exports.subsClone = subsClone;
exports.subsEq = subsEq;
exports.subsHash = subsHash;
exports.createConstParts = createConstParts;
exports.createMatchingConstParts = createMatchingConstParts;
exports.createVarGroups = createVarGroups;
exports.createSubs = createSubs;
exports.prepareFrmSubsDataForFrame = prepareFrmSubsDataForFrame;
exports.prepareFrmSubsData = prepareFrmSubsData;
exports.iterateSubstitutions = iterateSubstitutions;
exports.applySubs = applySubs;
exports.verifyDisjoints = verifyDisjoints;
exports.test_iterateConstParts = test_iterateConstParts;
exports.test_iterateSubstitutions = test_iterateSubstitutions;
/* MM_context Not a pure module */
